import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../../../Redux/store";

interface Writer {
    salesRepWriterId?: string | null;
    salesRepWriterName?: string | null;
    salesRepWriterUsername?: string | null;
    salesRepWriterBranchId?: string | null;
};

const initialState: Writer = {
    salesRepWriterId: null,
    salesRepWriterName: null,
    salesRepWriterUsername: null,
    salesRepWriterBranchId: null,
}

const writerSlice = createSlice({
    name: 'writer',
    initialState,
    reducers: {
        setSalesRepWriterId: (state, action) => {
            Object.assign(state, action.payload);
        },
        clearSalesRepWriter: (state) => {
            Object.assign(state, initialState);
        },
    },
});

export const writerReducer = writerSlice.reducer;
export const { 
    setSalesRepWriterId,
    clearSalesRepWriter,
} = writerSlice.actions;

export const getWriterId = (state: RootState) => {
    return state.writer.salesRepWriterId;
}
export const getWriterName = (state: RootState) => {
    return state.writer.salesRepWriterName;
}

